import { useCan } from "./useCan";

interface CanProps {
  /** The permission required to render the children (e.g. CustomerPermissions.AddMeter). */
  permission: number;
  children: React.ReactNode;
  /** Rendered instead of the children when the permission is missing. Defaults to nothing. */
  fallback?: React.ReactNode;
}

/**
 * Render-guard for actions and UI parts: shows its children only if the logged-in
 * user has `permission` (checked against the JWT via useCan). Feature flags are NOT
 * checked here — action visibility depends on permission alone.
 *
 * <Can permission={CustomerPermissions.AddMeter}><AddMeterButton /></Can>
 */
export default function Can({ permission, children, fallback = null }: CanProps) {
  const { can } = useCan();
  return <>{can(permission) ? children : fallback}</>;
}
